<template>
  <div class="table" style="padding:10px">
   <a-row type="flex" justify="space-between" align="middle"  style="margin-bottom:10px" v-if="layout.layoutType">
      <h4>配方营养需要量</h4>
      <a-space class="icon-bar">
        <slot />
        <!-- <a-button type='primary' @click="toggleVisible('nutChoose')" size="small">养分选择表</a-button> -->
        <a-tooltip>
          <template slot="title">养分选择表</template>
          <!-- <a-button type="link" icon="fork" @click="toggleVisible('nutChoose')" /> -->
          <a-button
            type="link"
            @click="toggleVisible('nutChoose')">
            <img :src="nutrientSelection" alt="养分选择表" />
          </a-button>
        </a-tooltip>
        <nut-filter-value @change="filterList"/>
        <table-filter-col type="nut" />
      </a-space>
    </a-row>
    <resize-table
     :scroll="{ x: 320, y: detail.referPriceSource ? height - 45 : height }"
      :columns="nutColumnsValue"
      tableName="nutTableColumns"
      bordered
      :loading="nutritonListLoading"
      :data-source="list.records"
      :row-key="record => record.id"
      :row-selection="{selectedRowKeys:selectedRowKeys, onChange: onSelectChange,getCheckboxProps}"
      :pagination="false"
      :rowClassName="rowClassname"
    >
      <span slot="customTitle"><a-icon @click="fixedCol"  type="pushpin" :theme="filled ? 'filled' : 'outlined'" /> 指标名称</span>
      <a-tooltip size="small" slot="nutritionName" slot-scope="text,item">
        <a @click="viewNut(item)">{{text}}</a>
        <!-- <template slot="title">查看养分贡献</template> -->
        <template slot="title">{{text}}</template>
      </a-tooltip>
      <template slot="content" slot-scope="text,record">
        {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
      </template>
      <template slot="productContent" slot-scope="text,record">
        {{text|numberFixed(record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2)}}
      </template>
      <template slot="cost" slot-scope="text">
        {{!text ? '' : text.toFixed(3)}}
      </template>
      <span v-for="col in ['minApply', 'maxApply','minValue', 'maxValue', 'minLimitValue','maxLimitValue']" slot-scope="text, record" :slot="col" :key="col">
        <span v-if="['minApply', 'maxApply', 'minLimitValue','maxLimitValue'].includes(col)">
          {{text|numberFixed(len2(record,col))}}
        </span>
        <cell-editor
          v-else
          :len="len(record,col)"
          :item="record"
          :name="col"
          :background="true"
          @blur="target => itemUpdate(target,record.id)"
          :text="text"
          :actions="update"
        />
      </span>

      <template slot="option" slot-scope="text,record">
        <a-space v-if="record.editable">
          <a-button type="primary" size="small" @click="() =>saveHandle(record.id)" :loading="updateLoading" style="font-size:12px">保存</a-button>
          <a-button size="small" style="font-size:12px" @click="() => cancelHandle(record.id)">取消</a-button>
        </a-space>
        <span v-else class="save_class">
          <a-button size="small" type="link" @click="() => eidtorItem(record.id)">编辑</a-button>
        </span>
      </template>
    </resize-table>
    <nutrition-raw-need-modal />
    <nutrition-modal :linkId="detail.linkId"  @ok="addNutrition" @cancel="toggleVisible('nutChoose')" :hidden="visible.nutChoose" @view="setDetail" />
    <nutrition-detail-modal :item="selectItem" :hidden="detailVisible" @cancel="toggleDetailVisible" />
  </div>
</template>
<script>
import {nhfMixins} from '../../untils'
import NutritionDetailModal from '../modal/NutritionDetailModal.vue'
import NutritionModal from '../modal/NutritionModal.vue'
import NutritionRawNeedModal from '../modal/NutritionRawNeedModal.vue'
import CellEditor from './CellEditor.vue'
import TableFilterCol from './TableFilterCol.vue'
import NutFilterValue from './NutFilterValue.vue'
import nutrientSelection from '@/assets/images/icon/nutrientSelection.png'

export default {
  components: { NutritionModal, NutritionDetailModal, CellEditor, NutritionRawNeedModal,TableFilterCol ,NutFilterValue},
  mixins:[nhfMixins],
  data(){
    return{
      nutrientSelection,
      nutritonListLoading:false,
      priceSource:null,
      chooseVisible:false,
      list:{
        records:[]
      },
      // 指标名称、指标全称、数值、单位、最小值、最大值、单位成本、适用下限、适用上限、极下限、极上限
      detailVisible:false,
      selectItem:{},
      filterAction: null,
      filled: true,
      cacheData: []
    }
  },

  mounted(){
    const {id} = this.$route.query
    this.formulaId = id
  },

  watch:{
    selectedRows(nutRows){
      this.$emit('select',nutRows,1)
      this.setState({nutSelect:nutRows[0],nutRows})
    },
  },
  computed:{
    listData(){
      return {
        rawIds:this.selectedRowKeys.join(),
        formulaId:this.formulaId
      }
    }
  },

  methods:{
    rowClassname(record){
      return record.isRawDelete == 1 ? 'selectGary' : ''
    },
    changeColumns2(){
      let nutColumnsValue = [...this.nutColumnsValue]
      if(this.filled){
        nutColumnsValue[0].fixed = 'left'
      }else{
        delete nutColumnsValue[0].fixed
      }
      this.setState({nutColumnsValue})
    },
    fixedCol(e){
      this.filled = !this.filled
      this.changeColumns2()
      e = e || window.event;
      if(e.stopPropagation) { //W3C阻止冒泡方法
          e.stopPropagation();
      } else {
          e.cancelBubble = true; //IE阻止冒泡方法
      }
    },
    async filterList(filterAction){
      this.filterAction = filterAction
      this.getFilterList()
    },
    len(record){
      return record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2
    },
    len2(record,col){
      let len = 3
      if(['minValue', 'maxValue', 'minLimitValue','maxLimitValue'].includes(col)){
        len = 2
        if((record.unit ==='MJ' || record.unit === 'Kcal'))len = 0
      }
      return len
    },
    viewNut(nutSelect){
      this.setState({nutSelect})
      this.toggleVisible('nut')
    },
    toggleDetailVisible(){
      this.detailVisible = !this.detailVisible
    },
    cleanSelect(){
      this.selectedRowKeys=[]
      this.selectedRows=[]
    },
    setDetail(item){
      this.selectItem = item
      this.toggleDetailVisible()
      this.toggleVisible('nutChoose')
    },
    itemChange(value, id, column) {
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      if (target) {
        target[column] = value
        this.list.records = newData
      }
    },
    eidtorItem(id){
      const newData = [...this.list.records]
      const target = newData.filter(item => id === item.id)[0]
      this.editingKey = id
      if (target) {
        target.editable = true
        this.list.records = newData
      }
    },
    saveHandle(key){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const target = newData.filter(item => key === item.id)[0]
      const targetCache = newCacheData.filter(item => key === item.id)[0]
      if (target && targetCache) {
        delete target.editable
        this.list.records = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
        this.update(target)
      }
    },
    itemUpdate(item,id){
      const newData = [...this.list.records]
      const newCacheData = [...this.cacheData]
      const targets = newData.filter(item => id === item.id)[0]
      const targetCache = newCacheData.filter(item => id === item.id)[0]
      if (targets && targetCache) {
        this.list.records = newData
        Object.assign(targetCache, item)
        Object.assign(targets, item)
        this.cacheData = newCacheData
        this.list.records = newData
      }
    },

    async update(arg){
      let data = JSON.parse(JSON.stringify(arg))
      delete data.nutritionFullName
      const response  = await this.fetchPost({
        actions:this.formulanutritionUpdate,
        data,
        showMessage:false
      })
      if(response.code === 200){
        await this.fetchPost({
          actions: this.formulanutritionUpdateCache,
          data,
          showMessage: false
        });
      }
      this.$emit('refresh',false,false)
    },

    cancelHandle(id){
      let newData = [...this.list.records]
      let target = newData.filter(item => id === item.id)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter(item => id === item.id)[0]);
        target.editable = false
        this.list.records = newData
      }
    },

    restetList(){
      this.$confirm({
        title: '提示',
        content: '确认将选中的营养指标恢复至默认值吗？',
        okText: '继续',
        cancelText: '取消',
        onOk: async () =>{
          this.resetNutrition()
        },
        onCancel(){},
      })
    },

    async resetNutrition(){
      this.fetchPost({
        actions:this.resetFormulaNutritionIds,
        data:{
          formulaId:this.formulaId,
          ids:this.selectedRows.map(i=>i.id).join()
        }
      })
      this.getList()
    },

    async addNutrition(row){
      this.nutritonListLoading = true
      this.toggleVisible('nutChoose')
      await this.fetchPost({
        actions:this.saveFormulaNutritionId,
        data:{
          formulaId:this.formulaId,
          ids:row.map(i=>i.id).join()
        }
      })
      this.$emit('res')
      this.getList()
    },

    async getList(arg = {}){
      this.list.records = []
        if(!this.formulaId) return
        let res = await this.fetchGet({
        isList:true,
        loading:'nutritonListLoading',
        actions:this.formulaNutritionNhfPage,
        name:'list',
        data:{
          formulaId:this.formulaId,
          ...arg,
          size:1000
        }
      })
      this.cleanSelect()
      let {data} = res || {}
      let {records} = data || {}
      this.cacheData = JSON.parse(JSON.stringify(records || []))
      this.getFilterList()
      // if(filterAction && data?.records) this.list.records = data.records.filter(filterAction))
      return res
    },
    getFilterList(){
      const list = JSON.parse(JSON.stringify(this.cacheData || [])) || []
      if(list && list.length){
        if(this.filterAction){
          this.list.records = list.filter(this.filterAction)
        }else{
          this.list.records = list
        }
      }
    },
    listChange(page){
      this.getList({...this.tablePageChange(page),...this.filterData})
    },
  }
}
</script>

<style lang="scss" scoped>
  .icon-bar ::v-deep .anticon{
    font-size:16px !important;
  }
  h3{
    margin: 0;
  }
  .red{color: red;}
  .green{color: green;}

  .selectGary{
    background-color: rgba(130, 130, 130, 0.1) !important;
  }
</style>
